(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["player-profile"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('player-profile-block')) {
    class PlayerProfileBlock extends HTMLElement {
      connectedCallback() {
        const toggle = this.querySelector('[data-player-profile-toggle]');
        const body = this.querySelector('[data-player-profile-body]');
        if (!toggle || !body) return;

        toggle.addEventListener('click', function () {
          const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!isExpanded));
          body.classList.toggle('is-collapsed', isExpanded);
        });
      }
    }
    customElements.define('player-profile-block', PlayerProfileBlock);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-specs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-specs-table')) {
    class ProductSpecsTable extends HTMLElement {}
    customElements.define('product-specs-table', ProductSpecsTable);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["restock-status"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('restock-status-block')) {
    class RestockStatusBlock extends HTMLElement {
      connectedCallback() {
        const toggle = this.querySelector('[data-restock-status-toggle]');
        const body = this.querySelector('[data-restock-status-body]');
        if (!toggle || !body) return;

        toggle.addEventListener('click', function () {
          const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!isExpanded));
          body.classList.toggle('is-collapsed', isExpanded);
        });
      }
    }
    customElements.define('restock-status-block', RestockStatusBlock);
  }
  } catch(e) { console.error(e); }
})();

})();
